<div class="page-content api-page-content">
  <div class="api-wrapper">
    <h4>Get more insights</h4>
    <p class="insight-note">Here you can explore the Developer Documentation that includes the API details.</p>
    <div class="insight-button-holder d-flex">
      <a href="https://api-doc.telqtele.com/#introduction" target="_blank" class="btn btn-primary px-20"
        >Developer documentation <span class="icon-external"></span
      ></a>
    </div>
  </div>

  <div class="api-wrapper">
    <form [formGroup]="form">
      <h4 class="api-heading">Use TelQ platform via API</h4>
      <div class="api-toogle">
        <div class="form-check form-switch">
          <input
            [disabled]="settingsLoading()"
            type="checkbox"
            class="form-check-input"
            [ngModel]="settingsEnabled()"
            (change)="onChangeEnabled($event.target.checked)"
            formControlName="enabled" />
        </div>
        <div class="api-toogle-text">
          <h4>API Enabled</h4>
          <p class="text-neutral-n8">
            Testing via API is similar to testing with no integration, the only difference being the fact that you do not have to log in to TelQ
            platform in order to issue the test requests – in case of API, the test requests are made via API.
          </p>
        </div>
      </div>
      @if (settingsEnabled()) {
        <div class="input-holder detail-box-wrap">
          <label class="form-label">Allowed IP addresses</label>
          <div class="d-flex my-10">
            @for (ip of allowedIps(); track ip) {
              <div class="pills-btn">
                <span class="text">{{ ip }}</span>
                <span class="icon" (click)="removeIpFromList(ip)">
                  <span class="icon-close"></span>
                </span>
              </div>
            }
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Enter allowed source IP address and hit enter"
            formControlName="ip"
            (keyup.enter)="addIpToList()"
            (blur)="addIpToList()" />
          <input-errors [control]="form.controls.ip" [service]="validationService"></input-errors>
          <span class="api-note mt-10"
            >Set up ‘Allowed IPs’ in order to whitelist only specific IPs for API integration with TelQ. Please make sure not to use this option in
            case you are using a dynamic IP (with no IPs added, any IP will be allowed).</span
          >
        </div>

        <div class="detail-box-wrap credentials-wrapper">
          <label class="form-label">Credentials</label>

          @if (apiCredentials().length === 0) {
            <div class="credentials-empty">No credentials yet.</div>
          } @else {
            @for (credential of apiCredentials(); track credential.appId) {
              @let credentialState = getCredentialState(credential.appId);

              <div class="credential-item">
                <div class="credential-main">
                  <div class="detail-box">
                    <h5 class="detail-title">App ID</h5>
                    <div class="api-box-holder">
                      <div class="api-box">{{ credential.appId }}</div>
                      <div class="copy-btn" (click)="onClickCopy(credential.appId + '')">
                        <span class="icon icon-copy"></span>
                        <span class="text">Copy</span>
                      </div>
                    </div>
                  </div>

                  <div class="detail-box">
                    <h5 class="detail-title">App Key</h5>
                    <div class="d-flex gap-0_2 align-items-center">
                      @if (credentialState.appKey) {
                        <div class="d-flex gap-0_2 align-items-center">
                          <div class="api-box">{{ credentialState.appKey }}</div>
                          <div class="action-btn copy-btn" (click)="onClickCopy(credentialState.appKey)">
                            <span class="icon icon-copy"></span>
                            <span class="text">Copy</span>
                          </div>
                        </div>
                      } @else {
                        <div class="api-box">*****</div>
                      }

                      <button
                        type="button"
                        class="action-btn action-btn__regenerate"
                        [disabled]="credentialState.isActionApplied"
                        [tooltip]="'Regenerate the App key for this app'"
                        (click)="onClickRegenerate(credential)">
                        <span class="fa fa-sync-alt"></span>
                      </button>

                      @if (canDeleteCredential()) {
                        <button
                          type="button"
                          class="action-btn action-btn__delete"
                          [tooltip]="canDeleteCredential() ? 'Delete the credentials for this app' : 'You can not delete the last credentials'"
                          [disabled]="credentialState.isActionApplied || !canDeleteCredential()"
                          (click)="onClickDelete(credential)">
                          <span class="far fa-trash-alt"></span>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          }

          <div class="credentials-footer">
            <button
              [tooltip]="!canCreateCredential() ? 'Max limit of credentials reached' : ''"
              type="button"
              class="btn btn-outline-primary"
              [class.btn-disabled]="!canCreateCredential()"
              (click)="createCredential()">
              Create new credentials
            </button>
          </div>
        </div>
      }
    </form>
    <div class="api-apply">
      <button [disabled]="settingsLoading()" (click)="onSubmit()" class="btn btn-primary">Apply</button>
    </div>
  </div>

  <div class="api-wrapper">
    <h4 style="margin-bottom: 1rem">Callbacks for "Live number testing" tests</h4>
    <form [formGroup]="formLnt">
      @if (isMain()) {
        <div class="detail-box-wrap" style="border-top: none">
          <div class="input-holder">
            <label class="form-label">General callback URL</label>
          </div>
          <input
            type="text"
            [(ngModel)]="generalCallbackUrlLiveTesting"
            class="form-control"
            placeholder="Enter url"
            formControlName="generalCallbackUrlLiveTesting" />
          <input-errors [control]="formLnt.controls.generalCallbackUrlLiveTesting" [service]="validationService"></input-errors>
          <span class="api-note mt-10"
            >The results of all the "Live number testing" tests - for all the users in your company - will be sent to this URL</span
          >
        </div>
      }

      <div class="detail-box-wrap" style="border-top: none">
        <div class="input-holder">
          <label class="form-label">Individual callback URL</label>
        </div>
        <input
          type="text"
          [(ngModel)]="callbackUrlLiveTesting"
          class="form-control"
          placeholder="Enter url"
          formControlName="callbackUrlLiveTesting" />
        <input-errors [control]="formLnt.controls.callbackUrlLiveTesting" [service]="validationService"></input-errors>
        <span class="api-note mt-10">The results of this account’s "Live number testing" tests will be sent to this URL</span>
      </div>
    </form>
    <div class="api-apply d-flex justify-content-between">
      <button (click)="onSubmitLnt()" [disabled]="!formLnt.valid || loading()" class="btn btn-primary">Apply</button>
    </div>
  </div>
</div>

<ng-template #regenerateModal let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Generate new <span class="icon-help-1 ml-15"></span></h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body mb-15">
    <div class="row">
      <p>
        Please note that the generation of a new App Key will automatically invalidate the previous App Key. Tests requested with the old App Key will
        be rejected.
      </p>
    </div>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary ms-15" (click)="dialogRef.close(true)">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #deleteCredentialModal let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Delete credential</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body mb-15">
    <div class="row">
      <p>Delete credential for this App ID?</p>
      <p class="mb-0">This will permanently remove the credential pair.</p>
    </div>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-danger ms-15" (click)="dialogRef.close(true)">Delete</button>
    </div>
  </div>
</ng-template>
